import colors from "colors";
import { IconProps } from "./types";

export default function IcoPlus({
	color = colors.neutral["high-pure-50"],
	size = "14"
}: Readonly<IconProps>) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 13 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5 7L0.5 7M6.5 13L6.5 1"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
